module.exports = __webpack_public_path__ + "media/MRI12A.67de2df2.mp3";